import { GlobalAlert } from '@thoughtspot/global-alert';
import { useTranslation } from '@thoughtspot/i18n';
import { Alert, BannerAlertType, } from '@thoughtspot/radiant-react/widgets/alert';
import { Horizontal, Vertical, } from '@thoughtspot/radiant-react/widgets/layout';
import { Modal, ModalSize } from '@thoughtspot/radiant-react/widgets/modal';
import React, { useEffect, useMemo, useState } from 'react';
import { TranslationsKeys } from '../../../../../authentication/constants';
import { useAuthSettingsVisibility, useScimToken } from '../../../shared';
import allOrgsStyles from './all-orgs-settings-modal.module.scss';
import { LocalAuthContent } from './local-auth-content.container';
import { ScimSection } from './scim-section';
import styles from './settings-modal.module.scss';
const ALL_SIDEBAR_TABS = [
    {
        tab: 'scim',
        translationKey: TranslationsKeys.SETTINGS_SIDEBAR_SCIM_PROVISIONING,
        testId: 'sidebar-scim',
    },
    {
        tab: 'localAuth',
        translationKey: TranslationsKeys.SETTINGS_SIDEBAR_LOCAL_AUTH,
        testId: 'sidebar-local-auth',
    },
];
export const SettingsModal = ({ onAction }) => {
    const { t } = useTranslation();
    const { showScim, showLocalAuth } = useAuthSettingsVisibility();
    const visibleTabs = useMemo(() => ALL_SIDEBAR_TABS.filter(({ tab }) => {
        if (tab === 'scim')
            return showScim;
        return showLocalAuth;
    }), [showScim, showLocalAuth]);
    const fallbackTab = visibleTabs[0]?.tab ?? 'scim';
    const [activeTab, setActiveTab] = useState(fallbackTab);
    useEffect(() => {
        if (!visibleTabs.some(entry => entry.tab === activeTab) &&
            visibleTabs.length) {
            setActiveTab(visibleTabs[0].tab);
        }
    }, [visibleTabs, activeTab]);
    const scim = useScimToken({ t });
    const close = () => scim.closeWithSavedToast(onAction);
    if (visibleTabs.length === 0) {
        return null;
    }
    const showSidebar = visibleTabs.length > 1;
    const renderContent = () => {
        if (activeTab === 'scim') {
            return (React.createElement(Vertical, { className: showSidebar ? allOrgsStyles.allOrgsContent : undefined, spacing: "f" },
                React.createElement(ScimSection, { scim: scim })));
        }
        return (React.createElement(Vertical, { className: showSidebar ? allOrgsStyles.allOrgsContent : undefined, spacing: "c" },
            React.createElement(Alert.Banner, { message: t(TranslationsKeys.INTERNAL_AUTH_FORM_CONTENT), isVisible: true, type: BannerAlertType.WARNING, showCloseButton: false, className: allOrgsStyles.allOrgsWarningBanner }),
            React.createElement(LocalAuthContent, { view: "localAuth", onSettingChanged: scim.markSettingsChanged, onSuccess: scim.notifySuccess, onError: scim.notifyError })));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Modal, { isOpen: true, onDismiss: close, size: ModalSize.MEDIUM3, title: t(TranslationsKeys.SETTINGS_MODAL_TITLE), className: styles.settingsModal, customHeaderClassName: styles.settingsModalHeader, confirmButton: { text: t('CLOSE'), onConfirm: close }, isContentLoading: scim.isInitialFetchLoading || scim.isMutationInFlight, "data-testid": "settings-modal" }, showSidebar ? (React.createElement(Horizontal, { className: allOrgsStyles.allOrgsModalBody },
            React.createElement(Vertical, { className: allOrgsStyles.allOrgsSidebar }, visibleTabs.map(({ tab, translationKey, testId }) => {
                const isActive = activeTab === tab;
                return (React.createElement("div", { key: tab, className: isActive
                        ? allOrgsStyles.allOrgsSidebarItemBoxShadow
                        : undefined },
                    React.createElement("div", { role: "button", tabIndex: 0, "data-testid": testId, className: `${allOrgsStyles.allOrgsSidebarItem} ${isActive
                            ? allOrgsStyles.allOrgsSidebarItemActive
                            : ''}`, onClick: () => setActiveTab(tab), onKeyDown: e => {
                            if (e.key === 'Enter' ||
                                e.key === ' ') {
                                e.preventDefault();
                                setActiveTab(tab);
                            }
                        } }, t(translationKey))));
            })),
            renderContent())) : (React.createElement(Vertical, { className: styles.settingsBody, spacing: "f" }, renderContent()))),
        React.createElement(GlobalAlert.Toast, { "data-testid": "settings-toast", message: scim.toastMessage, isVisible: scim.isToastVisible, onClose: scim.hideToast, autoHide: true })));
};
//# sourceMappingURL=settings-modal.container.js.map